import React from 'react';
import types from './types';
import percentToHex from '../PercentToHex';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import TextVariables from '../../../classes/TextVariables';
import TextUtils from '../../../classes/utilities/TextUtils';

export default function UIContainer(props)
{
	let properties = {
		'title': {
			type: 'textarea',
			default: props.title ? props.title : 'Container Title'
		},
		'title color': {
			type: 'color',
			default: '#ffffff'
		},
		'title alpha': {
			type: 'range',
			default: '80',
			step: 1,
		},
		// 'title background': {
		// 	type: 'color',
		// 	default: '#000000'
		// },
		// 'title background alpha': {
		// 	type: 'range',
		// 	default: '60'
		// },
		'background color': {
			type: 'color',
			default: '#5f5f5f'
		},
		'background alpha': {
			type: 'range',
			default: '80',
			step: 1,
		},
		'shadow color': {
			type: 'color',
			default: '#000000'
		},
		'shadow alpha': {
			type: 'range',
			default: '80',
			step: 1,
		},
		'title alignment': {
			type: 'align',
			default: props.align ? props.align : 'left'
		},
		'visible': {
			type: 'toggle',
			default: true
		}
	}

	if(props.getProperties)
	{
		return properties;
	}

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Container'}
				subcomponent={types.CONTAINER}
				properties={properties}
				{...props}
			/>
		)
	}
	else if (props.data.visible)
	{
		const simulation = props.context === "simulation";
		const data = props.data;
		// console.log(data);
		const titleColor = data['title color'].value + percentToHex(data['title alpha'].value);
		// const titleBackground = data['title background'].value + percentToHex(data['title background alpha'].value);
		const bgColor = data['background color'].value + percentToHex(data['background alpha'].value);
		const alignment = data['title alignment'].value;

		if(data['visible'].value !== true) return null;

		return (
			<div className={['uiContainerRoot', props.template].join(' ')}
				data-name={"ui-container-root"}
				style={{
					backgroundColor: bgColor,
					borderColor: data['shadow color'].value + percentToHex(data['shadow alpha'].value),
				}}
			>
				<div className={["uiContainerTitle ", props.template].join(' ')}
					data-name={"uiContainerTitle"}
					data-alignment={alignment}
					style={{
						color: titleColor,
						// backgroundColor: titleBackground,
						fontSize: simulation ? 58 : (20 * props.scale) + "px",
					}}
				>
					{TextUtils.convertNewlineToHtmlBreaks(TextVariables.textToData(data['title'].value))}
				</div>
			</div>
		);
	}

	return null;
}